import React from 'react';
import { CookiesCategory } from '@deliveroo/cookies-consent';

// if OneTrust is enabled for cookie consent management, we must render the
// GTM script type as "text/plain" to prevent it from executing immediately.
// OneTrust will convert this to "text/javascript" if we have consent for
// Performance and Functional cookies (or when the user consents).
export const gtmHeadSnippet = (isOneTrustEnabled) => (
  /* eslint-disable react/no-danger */
  <script
    type={isOneTrustEnabled ? 'text/plain' : 'text/javascript'}
    className={
      isOneTrustEnabled
        ? `optanon-category-${CookiesCategory.Performance}-${CookiesCategory.Functional}`
        : ''
    }
    dangerouslySetInnerHTML={{
      // eslint-disable-line react/no-danger
      __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-TXG89XM');`,
    }}
  />
  /* eslint-enable react/no-danger */
);

export const gtmBodySnippet = () => (
  /* eslint-disable jsx-a11y/iframe-has-title */
  <noscript>
    <iframe
      src="https://www.googletagmanager.com/ns.html?id=GTM-TXG89XM"
      height="0"
      width="0"
      style={{ display: 'none', visibility: 'hidden' }}
    />
  </noscript>
  /* eslint-enable jsx-a11y/iframe-has-title */
);
